// Hooki Reacta do magazynu bramy - każdy subskrybuje tylko swoją część (magazyn.ts).
import { useCallback, useSyncExternalStore } from "react";
import {
  odczyt,
  subskrybujPolaczenie,
  subskrybujSklad,
  subskrybujStatusy,
  subskrybujSztuke,
} from "./magazyn";

export function useSklad() {
  return useSyncExternalStore(subskrybujSklad, odczyt.sklad);
}

export function useWczytana() {
  return useSyncExternalStore(subskrybujSklad, odczyt.wczytana);
}

export function useStatusy() {
  return useSyncExternalStore(subskrybujStatusy, odczyt.statusy);
}

const bezStatusow = () => null;

/** Statusy tylko wtedy, gdy są potrzebne - inaczej zmiana statusu nie przerysowuje komponentu. */
export function useStatusyGdy(potrzebne: boolean) {
  return useSyncExternalStore(subskrybujStatusy, potrzebne ? odczyt.statusy : bezStatusow);
}

export function usePolaczenie() {
  return useSyncExternalStore(subskrybujPolaczenie, odczyt.polaczenie);
}

/** „Na żywo” przy połączonej bramie, inaczej chwila ostatnich danych (WYGLAD.md #10) - przerysowuje się tylko przy
 *  zmianie połączenia, nie przy każdej wiadomości. */
export function useNaZywo(): { naZywo: boolean; odswiezono: number } {
  const p = usePolaczenie();
  return { naZywo: p === "jest", odswiezono: p === "jest" ? 0 : odczyt.ostatnieDane() };
}

export function useSztuka(sn: string) {
  const sub = useCallback((s: () => void) => subskrybujSztuke(sn, s), [sn]);
  const get = useCallback(() => odczyt.sztuka(sn), [sn]);
  return useSyncExternalStore(sub, get);
}
